import { operations } from './generated/gcss';
import { GCSS_URLS } from '@/constants/api';
import { apiGcssFetcher } from '@/api/fetcher';
import { primeGcssCategoryCache } from '@/sections/gcss/functions/utils';
import { singleFlight } from '@/utils/promise';

export type CategoryListResponse =
	| operations['categories']['responses']['200']['content']['application/json']
	| undefined;

const loadCategoriesList = singleFlight(fetchCategoriesList);

export async function getCategoriesList(): Promise<NonNullable<CategoryListResponse>> {
	const data = await loadCategoriesList();

	await primeGcssCategoryCache();

	return data;
}

async function fetchCategoriesList(): Promise<NonNullable<CategoryListResponse>> {
	const res = await apiGcssFetcher<Promise<CategoryListResponse>>(GCSS_URLS.categoryList);

	const data = await res?.json;

	if (!data) {
		return [];
	}

	return data;
}
